import request from '../utils'

const assetTypeApi = {
    assetTypeList: async (modelingId) => {
        const req = request.get(`/api/modeling/${modelingId}/assetType`)
        const res = await req;
        return res.body;
    }, 
    assetTypeDetail: async (modelingId, assetType) => {
        const req = request.get(`/api/modeling/${modelingId}/assetType/${assetType}`)
        const res = await req;
        return res.body;
    },
    assetTypeUpdate: async (modelingId, assetType) => {
        const req = request.put(`/api/modeling/${modelingId}/assetType/${assetType.id}`).send(assetType);
        const res = await req;
        return res.body;
    },
    assetTypeCreate: async (modelingId, assetType) => {
        const req = request.post(`/api/modeling/${modelingId}/assetType`).send(assetType);
        const res = await req;
        return res.body;
    },
    assetTypeDelete: async (modelingId, assetTypeId) => {
        const req = request.delete(`/api/modeling/${modelingId}/assetType/${assetTypeId}`);
        await req;
    }
};

export default assetTypeApi